import React, { useState } from "react";
import { Tabs, Tab, Box, Typography, Stack, Paper, Divider } from "@mui/material";
import DoList from "./DoList";


function POBottomTabs({ dos, poIdStrg, poStatus }) {
  const [activeTab, setActiveTab] = useState(0);
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };


  const renderContent = () => {
    switch (activeTab) {
      case 0:
        return (
          <Paper elevation={0} sx={{ p: 2, pb: 4, mt: 2, border: '1px solid rgba(0,0,0,0.2)', borderRadius: 2 }}>
            {(poStatus !== "new" && poStatus !== "acknowledged") ? <Stack >
              <DoList height={"70vh"} dos={dos} poIdStrg={poIdStrg} poStatus={poStatus} />
            </Stack> : <Stack width={"100%"} alignItems={"center"} justifyContent={"center"} height={100}>
              Not Available
            </Stack>}
          </Paper>
        );
      default: return null;
    }
  };
  return (

    <Box sx={{ width: "100%" }}>
      <Divider />
      <Tabs value={activeTab} onChange={handleTabChange} textColor="inherit" indicatorColor="primary" >
        <Tab label="Delivery Orders" sx={{
          bgcolor: activeTab === 0 ? "primary.main" : "transparent",
          color: activeTab === 0 ? "black" : "rgba(0, 0, 0, 0.45)", borderRadius: "10px 10px 0 0",
          "&:hover": { bgcolor: "primary.light" },
        }} />
      </Tabs>
      <Box >
        <Divider sx={{ bgcolor: 'primary.main' }} />
        {renderContent()}
      </Box>
    </Box>

  )
}
export default POBottomTabs